import * as Yup from "yup";

export function initialValues(item) {
  return {
    title: item?.title || "",
    description: item?.description || "",
    driver: item?.driver || null,
    chain: item?.chain || "",
    exposure: item?.exposure || null,
    sensitivity: item?.sensitivity || null,
    adaptiveCapacity: item?.adaptiveCapacity || null,
    controls: item?.controls || "",
    action: item?.action || "",
  };
}

export function validationSchema(t) {
  return Yup.object({
    title: Yup.string().required(t("required_field")),
    exposure: Yup.number().min(1).max(5).required(t("required_field")),
    sensitivity: Yup.number().min(1).max(5).required(t("required_field")),
    adaptiveCapacity: Yup.number().min(1).max(5).required(t("required_field")),
  });
}
